import React from 'react';
import { Box } from '@hub/box';
import { TextWithJustHighlights } from './text-with-highlights';
import { StoreMediumIcon } from '@hub/icon';
import { getFieldForSegment, getSupplementaryTextForHit } from './display-utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function getDisplayNameForHit(hit) {
  const {
    segment
  } = hit;
  const isProduct = segment === 'westfieldProducts';
  return isProduct ? hit.name : hit.title;
}
export const DisplayForHitWithHiglighting = _ref => {
  let {
    hit,
    context
  } = _ref;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      '& > em': {
        fontWeight: 'medium'
      }
    },
    "data-id": "search_get-display-name-for-hit_DisplayForHitWithHiglighting_Box",
    children: [context.specialSearchKind === 'stores' && context.query.length === 0 && /*#__PURE__*/_jsx(StoreMediumIcon, {
      sx: {
        marginRight: 10
      },
      "data-id": "search_get-display-name-for-hit_DisplayForHitWithHiglighting_StoreMediumIcon"
    }), /*#__PURE__*/_jsx(TextWithJustHighlights, {
      doUseAutocompleteTags: true,
      field: getFieldForSegment(hit.segment),
      hit: hit,
      supplementaryText: getSupplementaryTextForHit(hit),
      "data-id": "search_get-display-name-for-hit_DisplayForHitWithHiglighting_Box_TextWithJustHighlights"
    })]
  });
};